// sticky-nav-buttons.js
(function ($) {
  // Wrap in IIFE with jQuery passed in for compatibility
  "use strict";

  $(document).ready(function () {
    const DEBUG = false;
    const $buttons = $(".sticky-nav__button");

    function log(...args) {
      if (DEBUG) console.log(...args);
    }

    function isMobileDevice() {
      const touchDevice = window.matchMedia(
        "(hover: none) and (pointer: coarse)",
      ).matches;
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileUA =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent,
        );
      return touchDevice || mobileUA;
    }

    log("Mobile device detected:", isMobileDevice());

    $buttons.each(function () {
      const $button = $(this);
      let isExpanded = false;
      let collapseTimer;

      // Add ARIA attributes if not present
      if (!$button.attr("aria-expanded")) {
        $button.attr("aria-expanded", "false");
      }

      const $textElement = $button.find(".text");
      const textId = "text-" + Math.random().toString(36).substr(2, 9);
      $textElement.attr("id", textId);
      $button.attr("aria-describedby", textId);

      function startCollapseTimer($btn) {
        clearTimeout(collapseTimer);
        collapseTimer = setTimeout(() => {
          $btn.removeClass("touch-expanded");
          $btn.attr("aria-expanded", "false");
          isExpanded = false;
          log("Auto-collapsed button", $textElement.text());
        }, 3000);
      }

      function expandButton(e) {
        if (isMobileDevice() && !isExpanded) {
          e.preventDefault();

          // Collapse other buttons first
          $buttons.not($button).each(function () {
            $(this).removeClass("touch-expanded");
            $(this).attr("aria-expanded", "false");
          });

          // Expand this button
          $button.addClass("touch-expanded");
          $button.attr("aria-expanded", "true");
          isExpanded = true;
          log("Expanded button", $textElement.text());

          // Start the auto-collapse timer
          startCollapseTimer($button);
        }
      }

      function collapseButton() {
        $button.removeClass("touch-expanded");
        $button.attr("aria-expanded", "false");
        isExpanded = false;
        clearTimeout(collapseTimer);
        log("Collapsed button", $textElement.text());
      }

      // Handle click/touch events
      $button.on("click", expandButton);

      // Reset expansion state when clicking outside
      $(document).on("touchstart", function (e) {
        if (!$button[0].contains(e.target)) {
          collapseButton();
        } else if (isExpanded) {
          startCollapseTimer($button);
        }
      });

      // Handle keyboard navigation
      $button.on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          expandButton(e);
        }

        if (e.key === "Escape") {
          collapseButton();
        }
      });

      // Ensure proper focus management
      $button.on("focus", function () {
        if (isMobileDevice()) {
          log("Button focused", $textElement.text());
        }
      });

      $button.on("blur", function () {
        if (isMobileDevice()) {
          // Optional: collapse on blur
          // collapseButton();
        }
      });
    });

    // Add a class to the body for CSS targeting
    if (isMobileDevice()) {
      $("body").addClass("is-touch-device");
    }
  });
})(jQuery);
